module.exports = __webpack_public_path__ + "img/icones_cedar.3d4070dc.png";